// extracted by mini-css-extract-plugin
export var bodySections = "_5d-8";
export var gray = "_5d-7";
export var green = "_5d-4";
export var iconContainer = "_5d-9";
export var iconWidgetContainer = "_5d-1";
export var phoneIcon = "_5d-2";
export var red = "_5d-5";
export var statusDot = "_5d-3";
export var widgetContainer = "_5d-0";
export var yellow = "_5d-6";